<template>
  <div>
    <FMethod/>

  </div>
</template>

<script>

import Vue from 'vue'
import {mapGetters} from 'vuex'
import FMethod from "@/projects/views/settings/methods/FMethod.vue";
export default {
  name: 'ConfigLogin',
  components: {FMethod},
  props: {
  },

  data: function () {
    return {

    }
  },

  mounted () {

  },

  created () {
    this.onInit()
  },

  beforeDestroy () {

  },

  methods: {
    onInit(){

    },

  },

  computed:{
    ...mapGetters({

    })
  },

  watch: {

  }

}
</script>
<style>

</style>
